export default "__VITE_ASSET__5vn90$$2__"